'use strict';

DoohApps.factory('CampaignValidator', ['ConfigurationBlockHelper', (function (ConfigBlockHelper) {
    return {
        IsValidCampaign: isValidCampaign
    }

    function isValidCampaign(application) {
        var Isvalid = true;

        var blockType = ConfigBlockHelper.configurationBlockType;

        angular.forEach(application.ConfigBlocks, function (block, SBk) {
            
            if (block.BlockName == blockType.slider) {
                if (block.ConfigurationValue.value == undefined) {
                    Isvalid = false;
                    block.error = 'Invalid value!'
                }
                else block.error = undefined;
            }

            if (block.BlockName == blockType.positioning || block.BlockName == blockType.region) {
                var error = false;
                if (block.ConfigurationValue.PositionRatio != undefined) {
                    if (block.ConfigurationValue.bottomRightX == undefined) error = true;
                    if (block.ConfigurationValue.bottomRightY == undefined) error = true;
                }
                if (error) {
                    Isvalid = false;
                    block.error = 'Invalid value!'
                }
                else block.error = undefined;
            }

            if (block.BlockName == blockType.colVidImgPickerWithAttachments) {
                if (block.Options[0].imageDurationLabel != undefined) {
                    angular.forEach(block.ConfigurationValue.ValueArray, function (val, key) {
                        if (val.Media != undefined) {
                            if (val.duration == undefined) {
                                if (val.Media.AssetType != 'video') {
                                    Isvalid = false;
                                    block.error = 'Invalid value!'
                                }
                                else block.error = undefined;
                            }
                        }

                    });
                }
            }

            if (block.ValidationParameters != ''
                && block.ValidationParameters != null
                && (block.ValidationParameters.startsWith('{') || block.ValidationParameters.startsWith('[')))
                angular.forEach(JSON.parse(block.ValidationParameters), function (valV, valK) {
                    switch (valV.Type) {
                        case 'Required':
                            var Isnull = isEmpty(block.ConfigurationValue);
                            if (Isnull) {
                                Isvalid = false;
                                block.error = valV.ErrorMessage;
                            }
                            else block.error = undefined;
                            break;
                        case 'IntMin':
                            if (isEmpty(block.ConfigurationValue) || Number(block.ConfigurationValue.value) > Number(valV.Value)) return;
                            if (Number(block.ConfigurationValue.value) < Number(valV.Value)) {
                                Isvalid = false;
                                block.error = valV.ErrorMessage;
                            }
                            else block.error = undefined;
                            break;
                        case 'IntMax':
                            if (isEmpty(block.ConfigurationValue) || Number(block.ConfigurationValue.value) < Number(valV.Value)) return;
                            if (Number(block.ConfigurationValue.value) > Number(valV.Value)) {
                                Isvalid = false;
                                block.error = valV.ErrorMessage;
                            }
                            else block.error = undefined;
                            break;
                    }
                });
        });


        return Isvalid;
    }

    function isEmpty(value) {
        if (angular.equals({}, value))
            return true;
        if (angular.equals([], value))
            return true;
        if (value.lenght == 0)
            return true;
        if (value.value === '')
            return true;
        if (value.value == null)
            return true;
        return false;
    }
})]);



